// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { EMRExportState, EMRExportType } from "../../types";
import { getEMRExports } from "../../api";

export const useEMRExports = (
  clinicId: string | undefined,
  connectionId: string | undefined,
  states: Array<EMRExportState>,
  limit: number,
  enabled: boolean
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<EMRExportType>>({
    queryKey: ["emr-exports", clinicId, connectionId, states, limit],
    queryFn: async () => {
      if (!clinicId || !connectionId) throw new Error();
      const token = await getToken();
      return getEMRExports(token, clinicId, connectionId, states, limit);
    },
    enabled: enabled && Boolean(clinicId && connectionId),
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};
